import { VueProductSpecItem } from "./spec-iterator/vue/VueProductSpecItem";
import { type CallbackUpdatedItem } from "./types";
import { create } from ".";
import { VueProductSpecIterator } from "./spec-iterator/vue/VueProductSpecIterator";

export function registerVueProductSpec({
    productId,
    secondsLeftGetter,
    callbackUpdatedItem,
}: {
    productId: number;
    //contextAuctionId: number,
    secondsLeftGetter: () => number;
    callbackUpdatedItem: CallbackUpdatedItem;
}): VueProductSpecItem {
    const registration = new VueProductSpecItem({
        productId,
        //contextAuctionId,
        secondsLeftGetter,
        callbackUpdatedItem,
    });
    VueProductSpecIterator.registrations.push(registration);
    create().initialize();
    return registration;
}
